import React from 'react';
import { Link } from 'react-router-dom';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import Button from '../../../artzu-ui/src/Button';

import { bmwSideViewLeft } from '../../../images/landingLinks';
import teslaSide from '../../../images/teslaSide.png';

const LandingSignup = ({ isVisible }) => (
  <div className="section fp-auto-height landing-signup grey-background">
    <div className="section-3__signup__wrapper">
      <div className="container section-3__signup">
        <div className="section-3__signup--left--nyc">
          <h2>Start Drivesharing Today</h2>
          <p className="section-3__signup--left--bold section-3__signup--left--bold--nyc">
            Requirements:
          </p>
          <div className="section-3__signup--condition section-3__signup--condition--nyc">
            <FontAwesomeIcon
              icon={faCheckCircle}
              fixedWidth
              size="1x"
              color="#128DFF"
              style={{ height: '2em' }}
            />
            <p>Must be at least 21 years old</p>
          </div>
          <div className="section-3__signup--condition section-3__signup--condition--nyc">
            <FontAwesomeIcon
              icon={faCheckCircle}
              fixedWidth
              size="1x"
              color="#128DFF"
              style={{ height: '2em' }}
            />
            <p>Have a valid driver’s license</p>
          </div>
          <div className="nyc__landing__signup__button">
            <Link to="/signup">
              <Button
                label="Sign Up"
                primary
                color="#128DFF"
                size="xl"
                className="nyc__landing__signup__button--signup"
              />
            </Link>
          </div>
        </div>
        {/* <div className="section-3__signup--right"> */}
        <div className="section-3__signup--right--nyc">
          <img
            className="section-3__car section-3__signup--right--toronto--img"
            src={teslaSide}
            alt="car"
          />
        </div>
      </div>
    </div>
  </div>
);

export default LandingSignup;



// WEBPACK FOOTER //
// ./src/components/Static/LandingPageLA/LandingSignup.js